import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

const debug = process.env.NODE_ENV !== 'prod';
const api = axios.create({ baseURL: '/.api/www' });

Vue.use(Vuex);

const state = {
  closedCourses: [],
};

const mutations = {
  ['SET_CLOSED_COURSE'](state, closedCourses) {
    state.closedCourses = closedCourses;
  },
};

const actions = {
  async getClosedCourses({ commit }, coursesData) {
    const { formatId, categoryId } = coursesData;
    try {
      const getClosedCourses = await api.get(`/pages/courses/closed`, {
        params: {
          format: formatId,
          category: categoryId,
        },
      });
      const {
        data: {
          data: { courses: closedCourses },
        },
      } = getClosedCourses;
      closedCourses && commit('SET_CLOSED_COURSE', [...closedCourses]);
    } catch (err) {
      throw new Error(err);
    }
  },
};

const store = new Vuex.Store({
  strict: debug,
  state,
  mutations,
  actions,
});

export default store;
